<template>
  <div v-editable="blok" class="relative">
    <div class="constrain py-8 lg:py-24 relative z-30">
      <div
        class="flex justify-between items-center"
        :class="`text-${titleAlignment}`"
      >
        <h2 class="heading-2">{{ blok.title }}</h2>
        <div v-if="blok.show_view_all_button">
          <Button
            as="nuxt-link"
            intent="primary-outline"
            to="/knowledge"
          >
            View all
          </Button>
        </div>
      </div>

      <!-- Articles Grid -->
      <div :class="`
        grid
        gap-4
        xl:gap-12
        mt-4
        lg:mt-16
        grid-cols-${blok.columns_base || 1}
        sm:grid-cols-${blok.columns_sm || 2}
        md:grid-cols-${blok.columns_md || 2}
        lg:grid-cols-${blok.columns_lg || 4}
        xl:grid-cols-${blok.columns_xl || 4}
      `">
        <!-- Loop through the guides -->
        <template v-for="article in articles" :key="article.uuid">
          <GuideCard :article="article.content" :slug="article.full_slug"/>
        </template>
      </div>
    </div>

    <!-- If you want to render gradients as well -->
    <Gradients :gradients="blok.gradients"/>
  </div>
</template>

<script setup lang="ts">
const props = defineProps({ blok: Object });
const storyblokApi = useStoryblokApi();
const { stripFormatting } = useSanitisedRichText();

const { data: articles, pending, error } = await useAsyncData('selected-articles', async () => {
  try {
    const response = await storyblokApi.get('cdn/stories', {
      version: 'published',
      by_uuids: props.blok.guides.join(','),
    });
    return response.data.stories;
  } catch (error) {
    console.error('Error fetching from Storyblok:', error);
  }
});

const titleAlignment = computed(() => {
  return props?.blok?.title_alignment || 'center';
});
</script>
